import {Injectable} from '@angular/core';
import {BaseModelService} from '../../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class CashClosingModelService extends BaseModelService {

  tableName = 'yu_v3_cash_closing';

}
